module.exports = __webpack_public_path__ + "static/media/28-8.08d79205.mp3";